module.exports = __webpack_public_path__ + "static/media/coupon-express.503396be.svg";